import React from "react";
import SimpleSlider from "./carousal";

const Reviews = () => {
  return (
    <div className="flex-col hidden sm:flex gap-9">
      <div className="flex flex-col gap-4">
        <h2 className="text-[#5254DB] text-center text-[20px] leading-[105%] tracking-[1.1px] uppercase">
          REVIEWS
        </h2>
        <p className="text-[#000] text-center text-[36px] font-semibold leading-[102%]">
          Words From Users Who Love Us!
        </p>
      </div>

      <div className="w-full !relative top-0">
        <img
          src="/img/webpImg/blueBg.webp"
          alt="Blue"
          className="absolute top-0 left-0 h-[500px] -z-50"
        />
        <SimpleSlider />
        <img
          src="/img/webpImg/blueBg.webp"
          alt="Blue"
          className="absolute top-0 right-0 h-[500px] -z-50 rotate-180"
        />
      </div>
    </div>
  );
};

export default Reviews;
